import { isPlatformBrowser } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
    selector: 'app-trending-brand',
    templateUrl: './trending-brand.component.html',
    styleUrls: ['./trending-brand.component.scss'],
    standalone: false
})
export class TrendingBrandComponent {
  @Input() brands:any = []

  @Output('onBannerClick') onBannerClick:EventEmitter<any> = new EventEmitter<any>();

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    autoplay: true,
    autoplayTimeout: 2000,
    dots: false,
    navSpeed: 700,
    items:5,
    nav: true,
    navText: [
      "<div class='nav-btn prev-slide'></div>",
      "<div class='nav-btn next-slide'></div>",
    ],
    responsive: {
      0: {
        items: 4,
      },
      480: {
        items: 2,
      },
      768: {
        items: 3,
      },
      992: {
        items: 4,
      }
    },
  };

  isBrowser = false 

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
  ){
    this.isBrowser = isPlatformBrowser(platformId)
  }

  onClick(banner){
    const analytic_type = 15
    this.onBannerClick.emit({banner,analytic_type})
  }
}
